export default __webpack_public_path__ + "static/product-unit-17-business-7a9f0b997558f5ebf58f33ef1fe9ee71.png";